import PropTypes from "prop-types";
import React from "react";

const classNames = (...names) => names.filter(Boolean).join(" ");

export const CcwChoiceCard = ({ className, control, controlId, help, helpId, label }) => (
  <div className={classNames("ccw-choice-card", className)}>
    <span className="ccw-choice-card__control">{control}</span>
    <span className="ccw-choice-card__body">
      <label className="ccw-choice-card__label" htmlFor={controlId}>
        {label}
      </label>
      {help && (
        <span id={helpId} className="ccw-field__help">
          {help}
        </span>
      )}
    </span>
  </div>
);

CcwChoiceCard.propTypes = {
  className: PropTypes.string,
  control: PropTypes.node.isRequired,
  controlId: PropTypes.string.isRequired,
  help: PropTypes.node,
  helpId: PropTypes.string,
  label: PropTypes.node.isRequired
};

CcwChoiceCard.defaultProps = {
  className: "",
  help: null,
  helpId: undefined
};

export const CcwCompactFieldGroup = ({ children, className, label, labelId }) => (
  <div
    className={classNames("ccw-field", "ccw-compact-field-group", className)}
    role="group"
    aria-labelledby={labelId}
  >
    <span id={labelId} className="ccw-field__label">
      {label}
    </span>
    <span className="ccw-field__control-group">{children}</span>
  </div>
);

CcwCompactFieldGroup.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  label: PropTypes.node.isRequired,
  labelId: PropTypes.string.isRequired
};

CcwCompactFieldGroup.defaultProps = {
  className: ""
};
